module.exports = __webpack_public_path__ + "img/womans-sandal.85a0585e.png";